/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull web'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 6
 * Build: 1.0.0
 * Runtime: browser:javascript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/e180/Braindate/implementation/web)
 */

import * as amplitude from '@amplitude/analytics-browser';

/**
 * @typedef BaseEvent
 * @type {object}
 * @property {string} event_type
 * @property {Object.<string, *>} [event_properties]
 */

/**
 * @typedef Plan
 * @type {object}
 * @property {string} [branch]
 * @property {string} [source]
 * @property {string} [version]
 * @property {string} [versionId]
 */

/**
 * @typedef LoadClientOptions
 * @type {object}
 * @property {string} [apiKey]
 * @property {Object} [configuration]
 * @property {BrowserClient} [instance]
 */

/**
 * @typedef LoadOptions
 * @type {object}
 * @property {'braindate'} [environment]
 * @property {boolean} [disabled]
 * @property {LoadClientOptions} [client]
 */

/**
 * @typedef {Object} EventOptions
 * @type {object}
 */

/**
 * @typedef ApiKey
 * @type {object}
 * @property {string} braindate
 */
export const ApiKey = {
  braindate: ''
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration = {
  plan: {
    version: '6',
    branch: 'main',
    source: 'web',
    versionId: 'c9dbf4da-9166-4727-8775-b8f2dc370691'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-javascript-ampli',
      sourceVersion: '2.0.0'
    }
  }
};

export class CarouselNavigation {
  constructor(properties) {
    this.event_type = 'Carousel Navigation';
    this.event_properties = properties;
  }
}

export class FormMultistepNavigation {
  constructor(properties) {
    this.event_type = 'Form Multistep Navigation';
    this.event_properties = properties;
  }
}

export class MenuMobileOpen {
  constructor(properties) {
    this.event_type = 'Menu Mobile Open';
    this.event_properties = properties;
  }
}

export class Notification {
  constructor(properties) {
    this.event_type = 'Notification';
    this.event_properties = properties;
  }
}

export class NotificationOpen {
  constructor(properties) {
    this.event_type = 'Notification Open';
    this.event_properties = properties;
  }
}

export class NotificationCleared {
  constructor(properties) {
    this.event_type = 'notification_cleared';
    this.event_properties = properties;
  }
}

export class OnboardingAgendaBack {
  constructor(properties) {
    this.event_type = 'Onboarding Agenda Back';
    this.event_properties = properties;
  }
}

export class OnboardingFinish {
  constructor(properties) {
    this.event_type = 'Onboarding Finish';
    this.event_properties = properties;
  }
}

export class OnboardingRecommendationPost {
  constructor(properties) {
    this.event_type = 'Onboarding Recommendation Post';
    this.event_properties = properties;
  }
}

export class OnboardingSkip {
  constructor(properties) {
    this.event_type = 'Onboarding Skip';
    this.event_properties = properties;
  }
}

export class OnboardingSkipAccept {
  constructor(properties) {
    this.event_type = 'Onboarding skip accept';
    this.event_properties = properties;
  }
}

export class OnboardingSkipAcceptOld {
  constructor(properties) {
    this.event_type = 'Onboarding Skip Accept_old';
    this.event_properties = properties;
  }
}

export class OnboardingSkipCancel {
  constructor(properties) {
    this.event_type = 'Onboarding Skip Cancel';
    this.event_properties = properties;
  }
}

export class OnboardingSkipStepOld {
  constructor(properties) {
    this.event_type = 'Onboarding skip step_old';
    this.event_properties = properties;
  }
}

export class OnboardingStart {
  constructor(properties) {
    this.event_type = 'Onboarding Start';
    this.event_properties = properties;
  }
}

export class TopicCreationAiOpen {
  constructor(properties) {
    this.event_type = 'Topic Creation AI Open';
    this.event_properties = properties;
  }
}

export class TopicCreationAiRestart {
  constructor(properties) {
    this.event_type = 'Topic Creation AI Restart';
    this.event_properties = properties;
  }
}

export class TopicCreationAiSelect {
  constructor(properties) {
    this.event_type = 'Topic Creation AI Select';
    this.event_properties = properties;
  }
}

export class TopicCreationClose {
  constructor(properties) {
    this.event_type = 'Topic Creation Close';
    this.event_properties = properties;
  }
}

export class TopicCreationModalClose {
  constructor(properties) {
    this.event_type = 'Topic Creation Modal Close';
    this.event_properties = properties;
  }
}

export class TopicCreationModalShare {
  constructor(properties) {
    this.event_type = 'Topic Creation Modal Share';
    this.event_properties = properties;
  }
}

export class TopicCreationPost {
  constructor(properties) {
    this.event_type = 'Topic Creation Post';
    this.event_properties = properties;
  }
}

export class TopicCreationStart {
  constructor(properties) {
    this.event_type = 'Topic Creation Start';
    this.event_properties = properties;
  }
}

export class TopicCreationStep1 {
  constructor(properties) {
    this.event_type = 'Topic Creation Step 1';
    this.event_properties = properties;
  }
}

export class TopicCreationStep2 {
  constructor(properties) {
    this.event_type = 'Topic Creation Step 2';
    this.event_properties = properties;
  }
}

export class TopicCreationStep2ChangeTitle {
  constructor(properties) {
    this.event_type = 'Topic Creation Step 2 Change Title';
    this.event_properties = properties;
  }
}

export class TopicCreationStep2ConfirmTime {
  constructor(properties) {
    this.event_type = 'Topic Creation Step 2 Confirm Time';
    this.event_properties = properties;
  }
}

export class TopicCreationStep3 {
  constructor() {
    this.event_type = 'Topic Creation Step 3';
  }
}

export class TopicJoinGroup {
  constructor(properties) {
    this.event_type = 'Topic Join Group';
    this.event_properties = properties;
  }
}

export class TopicCreationAiGenerated {
  constructor(properties) {
    this.event_type = 'topic_creation_ai_generated';
    this.event_properties = properties;
  }
}

export class TopicCreationAiSent {
  constructor(properties) {
    this.event_type = 'topic_creation_ai_sent';
    this.event_properties = properties;
  }
}

/**
 * @typedef PromiseResult
 * @type {object}
 * @property {Promise|undefined} promise
 */

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  constructor() {
    /* @type {BrowserClient|undefined} */
    this.amplitude = undefined;
    this.disabled = false;
  }

  /**
   * @return {BrowserClient}
   */
  get client() {
    this.isInitializedAndEnabled();
    return this.amplitude;
  }

  /**
   * @return {boolean}
   */
  get isLoaded() {
    return this.amplitude != null;
  }

  /**
   * @private
   * @return {boolean}
   */
  isInitializedAndEnabled() {
    if (!this.isLoaded) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param {LoadOptions} options Configuration options to initialize the Ampli SDK with. 'environment', 'client.apiKey' or 'client.instance' is required.
   *
   * @return {PromiseResult}
   */
  load(options) {
    this.disabled = options?.disabled ?? false;

    if (this.isLoaded) {
      console.warn('WARNING: Ampli is already initialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey;
    if (options?.client?.apiKey) {
      apiKey = options.client.apiKey;
    } else if (options?.environment) {
      apiKey = ApiKey[options.environment];
    }

    if (options?.client?.instance) {
      this.amplitude = options?.client?.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...options?.client?.configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user.
   *
   * @param {string|undefined} userId The user's id.
   * @param {EventOptions} [options] Optional event options.
   *
   * @return {PromiseResult}
   */
  identify(userId, options) {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options, user_id: userId};
    }

    const ampIdentify = new amplitude.Identify();
    return this.amplitude.identify(ampIdentify, options);
  }

  /**
  * Flush the event.
  */
  flush() {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude.flush();
  }

  /**
   * Track event
   *
   * @param {BaseEvent} event The event to track.
   * @param {EventOptions} [options] Optional event options.
   *
   * @return {PromiseResult}
   */
  track(event, options) {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude.track(event, undefined, options);
  }

  /**
   * Carousel Navigation
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Carousel%20Navigation)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {'previous'|'next'} properties.paginationDirection Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  carouselNavigation(properties, options) {
    return this.track(new CarouselNavigation(properties), options);
  }

  /**
   * Form Multistep Navigation
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Form%20Multistep%20Navigation)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {'previous'|'next'} properties.paginationDirection Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  formMultistepNavigation(properties, options) {
    return this.track(new FormMultistepNavigation(properties), options);
  }

  /**
   * Menu Mobile Open
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Menu%20Mobile%20Open)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  menuMobileOpen(properties, options) {
    return this.track(new MenuMobileOpen(properties), options);
  }

  /**
   * Notification
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Notification)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  notification(properties, options) {
    return this.track(new Notification(properties), options);
  }

  /**
   * Notification Open
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Notification%20Open)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  notificationOpen(properties, options) {
    return this.track(new NotificationOpen(properties), options);
  }

  /**
   * notification_cleared
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/notification_cleared)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  notificationCleared(properties, options) {
    return this.track(new NotificationCleared(properties), options);
  }

  /**
   * Onboarding Agenda Back
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Onboarding%20Agenda%20Back)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  onboardingAgendaBack(properties, options) {
    return this.track(new OnboardingAgendaBack(properties), options);
  }

  /**
   * Onboarding Finish
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Onboarding%20Finish)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  onboardingFinish(properties, options) {
    return this.track(new OnboardingFinish(properties), options);
  }

  /**
   * Onboarding Recommendation Post
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Onboarding%20Recommendation%20Post)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  onboardingRecommendationPost(properties, options) {
    return this.track(new OnboardingRecommendationPost(properties), options);
  }

  /**
   * Onboarding Skip
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Onboarding%20Skip)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  onboardingSkip(properties, options) {
    return this.track(new OnboardingSkip(properties), options);
  }

  /**
   * Onboarding skip accept
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Onboarding%20skip%20accept)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  onboardingSkipAccept(properties, options) {
    return this.track(new OnboardingSkipAccept(properties), options);
  }

  /**
   * Onboarding Skip Accept_old
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Onboarding%20Skip%20Accept_old)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  onboardingSkipAcceptOld(properties, options) {
    return this.track(new OnboardingSkipAcceptOld(properties), options);
  }

  /**
   * Onboarding Skip Cancel
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Onboarding%20Skip%20Cancel)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  onboardingSkipCancel(properties, options) {
    return this.track(new OnboardingSkipCancel(properties), options);
  }

  /**
   * Onboarding skip step_old
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Onboarding%20skip%20step_old)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string} properties.onboarding_step Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  onboardingSkipStepOld(properties, options) {
    return this.track(new OnboardingSkipStepOld(properties), options);
  }

  /**
   * Onboarding Start
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Onboarding%20Start)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  onboardingStart(properties, options) {
    return this.track(new OnboardingStart(properties), options);
  }

  /**
   * Topic Creation AI Open
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Creation%20AI%20Open)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationAiOpen(properties, options) {
    return this.track(new TopicCreationAiOpen(properties), options);
  }

  /**
   * Topic Creation AI Restart
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Creation%20AI%20Restart)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationAiRestart(properties, options) {
    return this.track(new TopicCreationAiRestart(properties), options);
  }

  /**
   * Topic Creation AI Select
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Creation%20AI%20Select)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {string} properties.Keywords Property has no description in tracking plan.
   * @param {string} properties.Value Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationAiSelect(properties, options) {
    return this.track(new TopicCreationAiSelect(properties), options);
  }

  /**
   * Topic Creation Close
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Creation%20Close)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationClose(properties, options) {
    return this.track(new TopicCreationClose(properties), options);
  }

  /**
   * Topic Creation Modal Close
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Creation%20Modal%20Close)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationModalClose(properties, options) {
    return this.track(new TopicCreationModalClose(properties), options);
  }

  /**
   * Topic Creation Modal Share
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Creation%20Modal%20Share)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationModalShare(properties, options) {
    return this.track(new TopicCreationModalShare(properties), options);
  }

  /**
   * Topic Creation Post
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Creation%20Post)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationPost(properties, options) {
    return this.track(new TopicCreationPost(properties), options);
  }

  /**
   * Topic Creation Start
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Creation%20Start)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {'Create Button'|'Modal'} properties.Topic Create Form Origin Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationStart(properties, options) {
    return this.track(new TopicCreationStart(properties), options);
  }

  /**
   * Topic Creation Step 1
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Creation%20Step%201)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationStep1(properties, options) {
    return this.track(new TopicCreationStep1(properties), options);
  }

  /**
   * Topic Creation Step 2
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Creation%20Step%202)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationStep2(properties, options) {
    return this.track(new TopicCreationStep2(properties), options);
  }

  /**
   * Topic Creation Step 2 Change Title
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Creation%20Step%202%20Change%20Title)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationStep2ChangeTitle(properties, options) {
    return this.track(new TopicCreationStep2ChangeTitle(properties), options);
  }

  /**
   * Topic Creation Step 2 Confirm Time
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Creation%20Step%202%20Confirm%20Time)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationStep2ConfirmTime(properties, options) {
    return this.track(new TopicCreationStep2ConfirmTime(properties), options);
  }

  /**
   * Topic Creation Step 3
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Creation%20Step%203)
   *
Event has no description in tracking plan.
   *
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationStep3(options) {
    return this.track(new TopicCreationStep3(), options);
  }

  /**
   * Topic Join Group
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/Topic%20Join%20Group)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {'recommendation'} properties.joinGroupOrigin Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicJoinGroup(properties, options) {
    return this.track(new TopicJoinGroup(properties), options);
  }

  /**
   * topic_creation_ai_generated
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/topic_creation_ai_generated)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationAiGenerated(properties, options) {
    return this.track(new TopicCreationAiGenerated(properties), options);
  }

  /**
   * topic_creation_ai_sent
   *
   * [View in Tracking Plan](https://data.amplitude.com/e180/Braindate/events/main/latest/topic_creation_ai_sent)
   *
Event has no description in tracking plan.
   *
   * @param {Object} properties The event's properties.
   * @param {string[]} properties.Features Property has no description in tracking plan.
   * @param {string} properties.value Property has no description in tracking plan.
   * @param {EventOptions} [options] Options for this track call.
   */
  topicCreationAiSent(properties, options) {
    return this.track(new TopicCreationAiSent(properties), options);
  }
}

export const ampli = new Ampli();
